import { render, staticRenderFns } from "./LoginProviderTutoWeb.vue?vue&type=template&id=06560bb1&scoped=true&"
import script from "./LoginProviderTutoWeb.vue?vue&type=script&lang=js&"
export * from "./LoginProviderTutoWeb.vue?vue&type=script&lang=js&"
import style0 from "./LoginProviderTutoWeb.vue?vue&type=style&index=0&id=06560bb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06560bb1",
  null
  
)

export default component.exports